import React from 'react';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ExpandList = () => {
    return (
        <svg
            fill='none'
            height='20'
            viewBox='0 0 9 20'
            width='9'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                clipRule='evenodd'
                d='M4.11501 0.863244C4.2261 0.752161 4.50028 0.5 4.50028 0.5C4.48516 0.5 4.7829 0.761914 4.88423 0.863244L8.3457 4.32472C8.3457 4.32472 7.57649 5.03992 7.57649 5.09394L5.04354 2.56099L5.04354 17.5334L7.57649 15.0005L8.3457 15.7697L4.88423 19.2312C4.77749 19.3379 4.49752 19.5985 4.49752 19.5985C4.49752 19.5985 4.22069 19.3369 4.11501 19.2312L0.65354 15.7697L1.42276 15.0005L3.9557 17.5334L3.9557 2.56099L1.42276 5.09394L0.65354 4.32472L4.11501 0.863244Z'
                fill='currentColor'
                fillRule='evenodd' />
        </svg>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

export default ExpandList;
